export default {
  subtitle: 'Trimitem prin POST evenimentele selectate către endpoint-urile tale, semnate cu secretul endpoint-ului.',
  regenerate_confirm: 'Generezi un nou secret de semnare? Secretul actual încetează imediat să funcționeze.',
  delete_confirm: 'Ștergi acest endpoint? Va înceta să primească evenimente.',
  consecutive_failures: '{{count}} eșecuri consecutive',
  columns: {
    url: 'Endpoint',
    events: 'Evenimente',
    status: 'Stare',
    secret: 'Secret',
  },
  statuses: {
    active: 'Activ',
    disabled: 'Dezactivat',
    auto_disabled: 'Auto-dezactivat',
  },
  buttons: {
    create: 'Adaugă endpoint',
    edit: 'Editează',
    regenerate_secret: 'Secret nou',
    delete: 'Șterge',
  },
  toasts: {
    load_error: 'Endpoint-urile webhook nu au putut fi încărcate.',
    error: 'Ceva nu a funcționat. Te rugăm să încerci din nou.',
    deleted: 'Endpoint șters.',
  },
};
